import { render, staticRenderFns } from "./altimeter.vue?vue&type=template&id=54509c2c&scoped=true"
import script from "./altimeter.vue?vue&type=script&lang=js"
export * from "./altimeter.vue?vue&type=script&lang=js"
import style0 from "./altimeter.vue?vue&type=style&index=0&id=54509c2c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54509c2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54509c2c')) {
      api.createRecord('54509c2c', component.options)
    } else {
      api.reload('54509c2c', component.options)
    }
    module.hot.accept("./altimeter.vue?vue&type=template&id=54509c2c&scoped=true", function () {
      api.rerender('54509c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/task/components/components/altimeter.vue"
export default component.exports